package one.healthium.tutorial.screens

import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.defaultMinSize
import androidx.compose.foundation.layout.fillMaxHeight
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.navigationBarsPadding
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.verticalScroll
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.unit.dp
import kotlinx.coroutines.launch
import loco.GENERAL_CONTINUE
import one.healthium.onboarding.ui.components.Notification
import one.healthium.onboarding.ui.user_binding.UserProvider
import one.healthium.onboarding.utils.NotificationPermissionRequester
import one.healthium.tutorial.domain.TutorialScreenConfig
import one.healthium.ui.compose.components.AppButton
import one.healthium.ui.compose.components.AppText
import one.healthium.ui.compose.theme.AppTheme
import org.jetbrains.compose.resources.stringResource

interface TutorialNotificationAccessEventDelegate {
    fun onNextClicked()
}

@Composable
fun TutorialNotificationAccessScreen(
    screenConfig: TutorialScreenConfig.TutorialNotificationsAccessScreenConfig,
    eventDelegate: TutorialNotificationAccessEventDelegate,
) {
    NotificationAccessScreenContent(
        onNextClicked = eventDelegate::onNextClicked,
        screenConfig = screenConfig
    )
}

@Composable
private fun NotificationAccessScreenContent(
    modifier: Modifier = Modifier,
    screenConfig: TutorialScreenConfig.TutorialNotificationsAccessScreenConfig,
    onNextClicked: () -> Unit,
) {
    val coroutineScope = rememberCoroutineScope()

    UserProvider {
        Column(
            modifier = modifier
                .navigationBarsPadding()
                .padding(horizontal = 24.dp)
                .fillMaxHeight()
                .verticalScroll(rememberScrollState()),
            horizontalAlignment = Alignment.CenterHorizontally,
        ) {
            Spacer(Modifier.height(36.dp))
            AppText(
                modifier = Modifier.padding(horizontal = 8.dp),
                text = screenConfig.title?.bindUserPlaceholders(),
                style = AppTheme.textStyles.secondary_30_500,
                color = AppTheme.colors.text100,
                textAlign = TextAlign.Center,
            )
            Spacer(Modifier.height(16.dp))
            AppText(
                modifier = Modifier.padding(horizontal = 8.dp),
                text = screenConfig.subtitle?.bindUserPlaceholders(),
                style = AppTheme.textStyles.secondary_18_400,
                color = AppTheme.colors.text500,
                textAlign = TextAlign.Center,
            )
            Spacer(Modifier.height(24.dp))
            Spacer(Modifier.weight(1f))
            screenConfig.notification?.let { Notification(it) }
            Spacer(Modifier.height(24.dp))
            Spacer(Modifier.weight(2.5f))
            NotificationPermissionRequester { request ->
                AppButton(
                    modifier = Modifier.defaultMinSize(minWidth = 176.dp),
                    onClick = {
                        coroutineScope.launch {
                            request()
                            onNextClicked()
                        }
                    },
                ) {
                    Text(text = screenConfig.ctaTitle ?: stringResource(loco.Res.string.GENERAL_CONTINUE))
                }
            }
            Spacer(Modifier.height(50.dp))
        }
    }
}